import { useConfig } from "@/contexts/cdpConfig";
import { VariantEnum } from "./types";
export const useGetNavbarVariant = () => {
    var _a;
    const featureFlags = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.featuresFlags;
    const variationFlag = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags["navigation_bar"];
    if (variationFlag === "b") {
        return { isNavigationBar: true, variant: VariantEnum.TABS };
    }
    if (variationFlag === "c") {
        return { isNavigationBar: true, variant: VariantEnum.TAGS };
    }
    return { isNavigationBar: false, variant: undefined };
};
